import { render, staticRenderFns } from "./CustomersCheckersQueueTable.vue?vue&type=template&id=1286d906&scoped=true&"
import script from "./CustomersCheckersQueueTable.vue?vue&type=script&lang=js&"
export * from "./CustomersCheckersQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomersCheckersQueueTable.vue?vue&type=style&index=0&id=1286d906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286d906",
  null
  
)

export default component.exports